import { SearchHandlerContext } from 'components/search/SearchContext';
import { SearchQueryStringParams } from 'components/search/utils';
import { calendarSelector, offeringsSelector } from 'selectors/calendarSelectors';
import { consumer } from '@tock/coretypes';
import { getNextRelease } from 'utils/businessUtils';
import { useApp } from 'selectors/appSelector';
import { useContext } from 'react';
import { useHistory } from 'react-router';
import { useQueryStringParams } from 'hooks/useQueryStringParams';
import { useSelector } from 'react-redux';
import ExperienceMenuModal from 'components/business/ExperienceMenuModal';

const SearchExperienceMenuModal: React.FunctionComponent = () => {
  const queryStringParams = useQueryStringParams<SearchQueryStringParams>();
  const { startOrder } = { ...useContext(SearchHandlerContext) };

  const app = useApp();
  const calendar = useSelector(calendarSelector);
  const offerings = useSelector(offeringsSelector);
  const history = useHistory();

  const experienceId = Number(queryStringParams.experienceId);

  const isOpen = queryStringParams.showModal === 'menu';

  const isAuthenticated = !!app.jwtToken;
  const nextRelease = getNextRelease(app.config);
  const business = app.config?.business as consumer.BusinessConfig | undefined;
  const isDataLoading = calendar.offeringsInProgress || app.configRequestInProgress || !business;
  return (
    <ExperienceMenuModal
      business={business}
      calendar={calendar}
      experienceId={experienceId}
      isAuthenticated={isAuthenticated}
      isLoading={isDataLoading}
      isOpen={isOpen}
      isRoute={false}
      isWidget={false}
      nextRelease={nextRelease}
      offerings={offerings}
      onClose={() => history.goBack()}
      onStartOrder={startOrder}
      patron={app.patron || undefined}
    />
  );
};

export default SearchExperienceMenuModal;
